import ZipCodesPage from "../../pages/legacy/zipCodes/ZipCodesPage";

const route = {
  key: "zipCodes",
  path: "/legacy/zip-codes",
  component: ZipCodesPage,
  private: true,
  layout: "main",
  icon: "faLocationDot",
  group: "masterdata",
  order: 50,
  permission: "legacy.zipCodes.read"
};

export default route;